import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { getShortId } from '../../modules/Utils/helpers';

const ShortIdWrapper = styled.span<ShortIdProps>`
    border: 2px solid ${({ theme }) => theme.divider};
    border-radius: 16px;
    color: ${({ theme }) => theme.secondaryText};
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.5rem;
    ${({ position }) =>
        position === 'absolute' &&
        css`
            position: absolute;
            bottom: 1rem;
            left: 1rem;
        `}
`;

type ShortIdProps = {
    position?: 'absolute' | 'relative';
    hideLabel?: boolean;
};

const ShortId = ({
    position = 'absolute',
    hideLabel = false,
}: ShortIdProps) => {
    const shortId = getShortId();
    if (!shortId || shortId === '') {
        return null;
    }
    return (
        <ShortIdWrapper position={position}>
            {hideLabel ? null : 'SnackTV'} {shortId}
        </ShortIdWrapper>
    );
};

export default ShortId;
